import { render, staticRenderFns } from "./SettingsConnectPaddle.vue?vue&type=template&id=36561882&"
import script from "./SettingsConnectPaddle.vue?vue&type=script&lang=js&"
export * from "./SettingsConnectPaddle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports